export default __webpack_public_path__ + "static/media/lockIconSVG.861ce657.svg";